import { FC } from 'react';
import { Stack } from '@optimus-web/core';
import { Account } from '@mews-commander/data-access';
import { ReservationBasicInfo } from '../ReservationBasicInfo';

export type PanelContentWrapperProps = React.PropsWithChildren<{
    resourceId: string | null | undefined;
    owner: Account | undefined;
}>;

export const PanelContentWrapper: FC<PanelContentWrapperProps> = ({ owner, resourceId, children }) => (
    <Stack vertical spacing="300" fill>
        {owner && resourceId && <ReservationBasicInfo owner={owner} resourceId={resourceId} />}
        {children}
    </Stack>
);
